module.exports = __webpack_public_path__ + "static/media/illustration_time_management.2f9210bb.svg";